module.exports = __webpack_public_path__ + "img/home_icon_shizheng_sel.6a624bbd.png";